import React from "react";
import "./index.less";

class listOfThirdSDK extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        // document.title = '权限列表';
        return (
            <div className="page_type_h5_select">
                <article id="listOfThirdSDK">
                    <h2 style={{ textAlign: "center" }}>第三方信息共享清单</h2>
                    <p>
                        我们仅会在您同意或其他依法可向第三方共享的情况下，向其提供您的个人信息。
                    </p>
                    <h3>一、我们的合作方共享说明</h3>
                    <p>1. 杭州天谷信息科技有限公司</p>
                    <p>使用场景： 实名认证</p>
                    <p>
                        处理目的： 签订租赁合同时将客户真实身份信息写入电子合同
                    </p>
                    <p>
                        提供的个人信息类型：
                        姓名、手机号码、身份证号、电子合同相关文件
                    </p>
                    <p>提供方式： 接口传输</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.esign.cn/gw/fwxy/?current=2"
                            style={{ color: "blue" }}
                        >
                            https://www.esign.cn/gw/fwxy/?current=2
                        </a>
                    </p>
                    <p>2. 通联支付网络服务股份有限公司</p>
                    <p>使用场景： 支付</p>
                    <p>处理目的： 用户进行微信、支付宝支付</p>
                    <p>
                        提供的个人信息类型： 用户标识信息、网络IP地址、订单金额
                    </p>
                    <p>提供方式： 接口对接，加密加签</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.allinpay.com/"
                            style={{ color: "blue" }}
                        >
                            https://www.allinpay.com/
                        </a>
                    </p>
                    <p>3、阿里云计算有限公司</p>
                    <p>使用场景： 短信服务</p>
                    <p>
                        处理目的：
                        平台业务通知、活动通知、验证码通知，通过短信将通知信息发送给客户
                    </p>
                    <p>提供的个人信息类型： 手机号</p>
                    <p>提供方式： 接口对接，加密加签</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.aliyun.com"
                            style={{ color: "blue" }}
                        >
                            https://www.aliyun.com
                        </a>
                    </p>
                    <p>4、阿里云计算有限公司</p>
                    <p>使用场景： OCR </p>
                    <p>处理目的： 识别车辆行驶证信息，识别车牌号信息</p>
                    <p>提供的个人信息类型： 车辆行驶证图片，车牌图片</p>
                    <p>提供方式： 接口对接，加密加签</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://help.aliyun.com/product/252763.html"
                            style={{ color: "blue" }}
                        >
                            https://help.aliyun.com/product/252763.html
                        </a>
                    </p>
                    <p>5、充电桩运营方</p>
                    <p>使用场景： 充电服务</p>
                    <p>处理目的：为用户提供充电服务；为用户提供免费停车服务</p>
                    <p>
                        提供的个人信息类型：
                        电站编码、充电桩二维码、充电订单号码；车牌号码
                    </p>
                    <p>提供方式： 接口对接，加密加签</p>
                    <p>隐私政策链接：详见各充电桩运营方网站 </p>
                    <p>6、北京沃丰时代数据科技有限公司</p>
                    <p>使用场景： 在线客服</p>
                    <p>处理目的：为用户提供在线客服服务</p>
                    <p>
                        提供的个人信息类型：联系方式、聊天文字、文件、图片、视频文件
                    </p>
                    <p>提供方式： 网页嵌入</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.udesk.cn/"
                            style={{ color: "blue" }}
                        >
                            https://www.udesk.cn/
                        </a>
                    </p>
                    <p>7. 杭州兑吧网络科技有限公司</p>
                    <p>使用场景： 积分功能</p>
                    <p>处理目的： 用户可以使用积分进行实物或虚拟商品的兑换。</p>
                    <p>提供的个人信息类型： 用户ID</p>
                    <p>提供方式： 接口传输</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://47171.activity-42.m.duiba.com.cn/customShare/share?id=Did1NTY0MzE"
                            style={{ color: "blue" }}
                        >
                            https://47171.activity-42.m.duiba.com.cn/customShare/share?id=Did1NTY0MzE
                        </a>
                    </p>
                    <p>8. 杭州数脉科技有限公司</p>
                    <p>使用场景： 实名认证</p>
                    <p>
                        处理目的：
                        为了进行人脸活体验证及身份信息一致性，签订合同时将客户真实身份信息写入电子合同
                    </p>
                    <p>
                        提供的个人信息类型：
                        人脸信息、姓名、证件类型、证件号码、证件有效期。
                    </p>
                    <p>提供方式： 接口传输</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.shumaiapi.com/support/112"
                            style={{ color: "blue" }}
                        >
                            https://www.shumaiapi.com/support/112
                        </a>
                    </p>
                    <p>二、第三方SDK说明</p>
                    <p>
                        除上述合作方（接口传输）的共享情况外，对于合作方（SDK形式）的共享情况详见《第三方SDK清单》。
                        <a
                            href="https://www.hellogil.com/h5Static/#/listOfThirdSDK"
                            style={{ color: "blue" }}
                        >
                            《第三方SDK清单》
                        </a>
                    </p>
                </article>
            </div>
        );
    }
}

export default listOfThirdSDK;



// WEBPACK FOOTER //
// ./src/staticPage/threeShareList/index.js